import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints";

/** Aktif Mikro hesaplarını ve vade farkı hizmet kodlarını getirir. */
export const GetAll = async (option = {}) => {
  const response = await $api.get(Endpoints.MikroAccount.GetAll(option));
  if (response?.success === true || response?.isSuccess === true) {
    return { ...response, message: response.message || "OK", isSuccess: true };
  }
  return ResponseChecker(defaultMessages, response);
};

/**
 * Vade farkı hizmet kartı kodunu günceller (Admin).
 * @param {{ paymentTermSurchargeServiceCode: string }} form
 * @param {{ params: { id: string } }} option
 */
export const UpdatePaymentTermSurchargeServiceCode = async (form, option) => {
  const response = await $api.put(
    Endpoints.MikroAccount.UpdatePaymentTermSurchargeServiceCode(option),
    form
  );
  if (response?.success === true || response?.isSuccess === true) {
    return { ...response, message: response.message || "OK", isSuccess: true };
  }
  return ResponseChecker(defaultMessages, response);
};

export default {
  GetAll,
  UpdatePaymentTermSurchargeServiceCode,
};
